import React from 'react';
import PropTypes from 'prop-types';

/*
  This is here mainly if we need to apply entry specific styles in the future
 */

const HistoryEntry = ({ children, ...other }) => <div style={{ cursor: 'pointer' }} {...other} children={children} />;

HistoryEntry.propTypes = {
  children: PropTypes.node.isRequired,
};

export default HistoryEntry;
